import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://jgpzbnolzlxikwxthlkz.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpncHpibm9semx4aWt3eHRobGt6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA2ODMwMjEsImV4cCI6MjA5NjI1OTAyMX0.ZwifptjN8bhpNSmzA1no_bMLYCV4FmSrOac96sS6fxY';

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});